import { ArrayField, ChipField, Datagrid, List, Show, SimpleShowLayout, SingleFieldList, TextField } from "react-admin";
import { TagsView } from "./list";



export function MomentShow() {
    return (
        <Show>
            <SimpleShowLayout>
                <TextField source="name" />
                <TextField source="description" />
                <TagsView source="tags" />
            </SimpleShowLayout>
        </Show>
    )
}   